import getAddinCollection from './getAddinCollection';
import { DIVIDER_DISPLAY_NAME } from './getDisplayNameFromKey';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';
import { convertToIContextualMenuItem, getReadHostItemIndex, getComposeHostItemIndex, } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
function addItemToSurfaceCollection(surfaceItems, item, isEndAligned) {
    // Mark the item and all subMenu items as pinned for telemetry.
    item.isPinned = true;
    if (item.subMenuProps) {
        item.subMenuProps.items.forEach(function (subItem) {
            subItem.isPinned = true;
        });
    }
    if (isEndAligned) {
        surfaceItems.unshift(item);
    }
    else {
        surfaceItems.push(item);
    }
}
function tryAddDivider(overflowItems, dividerKey) {
    var itemLength = overflowItems.length;
    if (itemLength > 0 && overflowItems[itemLength - 1].displayName != DIVIDER_DISPLAY_NAME) {
        overflowItems.push({
            key: "addinDivider_" + dividerKey,
            displayName: DIVIDER_DISPLAY_NAME,
            itemType: ContextualMenuItemType.Divider,
            onClick: null,
        });
    }
}
export default function populateCommandBarWithAddins(extMode, hostId, surfaceAddinKeys, surfaceItems, overflowItems, isEndAligned, dividerKey, className) {
    var installedAddins;
    var addinCollection = getAddinCollection(extMode);
    installedAddins = addinCollection ? addinCollection.sectionProps.items : [];
    var hostItemIndex = extMode == ExtensibilityModeEnum.MessageRead
        ? getReadHostItemIndex(hostId)
        : getComposeHostItemIndex(hostId);
    var shouldAddFirstDivider = true;
    installedAddins.forEach(function (addin) {
        convertToIContextualMenuItem(hostItemIndex, addin);
        var surfaceActionItem = addin;
        surfaceActionItem.iconOnly = true;
        if (className) {
            surfaceActionItem.className = className;
        }
        // Check if the user has this addin in their surface addins.
        if (surfaceAddinKeys.indexOf(addin.key) >= 0) {
            // If they do, add it to the surface items.
            // The surfaceActionItem title is actually the description for the add-in.
            // The ariaLabel is equivilent to name + " - " + title
            // For the most part, we'd like to use the ariaLabel for the pinned surface actions,
            // but if the name and title are the same, we should just use the name.
            if (surfaceActionItem.name != undefined &&
                surfaceActionItem.title != undefined &&
                surfaceActionItem.name.trim() != surfaceActionItem.title.trim()) {
                surfaceActionItem.name = surfaceActionItem.ariaLabel;
            }
            surfaceActionItem.title = '';
            addItemToSurfaceCollection(surfaceItems, surfaceActionItem, isEndAligned);
        }
        else {
            // If they don't, push it to the overflow, but first add a divider to separate addins from actions if needed.
            if (shouldAddFirstDivider) {
                tryAddDivider(overflowItems, dividerKey++);
                shouldAddFirstDivider = false;
            }
            // Mark the item and all subMenu items as rendered in overflow for telemetry.
            surfaceActionItem.renderedInOverflow = true;
            if (surfaceActionItem.subMenuProps) {
                surfaceActionItem.subMenuProps.items.forEach(function (subItem) {
                    subItem.renderedInOverflow = true;
                });
            }
            overflowItems.push(surfaceActionItem);
        }
    });
}
//# sourceMappingURL=populateCommandBarWithAddins.js.map